import DashboardRoutes from './dashboardRoutes';

export default DashboardRoutes;
